module.exports = __webpack_public_path__ + "assets/img/send.ffc67e1e.svg";